import { Injectable } from '@angular/core';
import { Subject, Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EmailRequestDto, ProjectDto } from '../models/emailrequestdto';

@Injectable({
  providedIn: 'root'
})
export class EmailNotificationService {

  private openPopupSource = new Subject<{ catId: number[], project: ProjectDto }>();
  openPopup$ = this.openPopupSource.asObservable();

  constructor(private httpClient: HttpClient) {}

  open(catId: any[], project: ProjectDto) {
    this.openPopupSource.next({ catId, project });
  }

  sendEmail(emailRequest: EmailRequestDto): Observable<boolean> {
    const url = `${environment.gateway_url}/sendemail`;
    return this.httpClient.post<boolean>(url, emailRequest).pipe(
      catchError((error: HttpErrorResponse): Observable<boolean> => {
        this.handleError(error);
        return of(false); // return a default value of type boolean
      })
    );
  }


  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Email sending error:', error);
    return throwError(() => new Error(error.message || 'Email send failed'));
  }
}
